import * as types from "@/store/taxcode/types";

export default {
  [types.SET_TAXCODELIST](state, payload) {
    state.taxcodeList = payload;
  },
  [types.SET_TAXCODEOBJECT](state, payload) {
    state.currentTaxcodeObject = payload;
  }
};
